var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activeQuestion)?_c('question-card',{ref:"questionCardRef",attrs:{"show-buttons":"","question":_vm.activeQuestion}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }